import React, {useEffect, useRef} from 'react';

import {trackEvent} from 'analytics/Analytics';
import {LLM_CHAT_ANALYTICS_ACTIONS} from 'constants/analytics-products/LLMChatConstants';
import {AgentType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {useRolloutFlags} from 'launchdarkly/LaunchDarklyUtil';
import {isAgentTypeEnabled} from 'llm/chat-library/sidepanel/ChatTypeUtil';
import {ButtonSize} from 'ui-library/buttons/Button';
import APIUtil from 'util/APIUtil';

import StartChatInput from './StartChatInput';

interface InventoryAskButtonProps {
  itemId: string;
}

export default function InventoryAskButton({itemId}: InventoryAskButtonProps): JSX.Element | null {
  const {llmEnableAskInventory} = useRolloutFlags();
  const hasTrackedImpression = useRef(false);
  const modelType = APIUtil.apiIdToType(itemId);

  useEffect(() => {
    hasTrackedImpression.current = false;
  }, [itemId]);

  useEffect(() => {
    if (llmEnableAskInventory && isAgentTypeEnabled(AgentType.ASK) && !hasTrackedImpression.current) {
      hasTrackedImpression.current = true;
      trackEvent(LLM_CHAT_ANALYTICS_ACTIONS.VIEWED_INVENTORY_ASK_BUTTON, {
        itemId,
        modelType,
      });
    }
  }, [itemId, modelType, llmEnableAskInventory]);

  if (!llmEnableAskInventory || !isAgentTypeEnabled(AgentType.ASK)) {
    return null;
  }

  return (
    <StartChatInput
      itemId={itemId}
      agentType={AgentType.ASK}
      buttonSize={ButtonSize.SMALL}
      extraAnalyticsProperties={{source: 'inventory'}}
    />
  );
}
